import { useSyncExternalStore } from 'react';
import { outbox } from './outbox';

export const useOutbox = () =>
  useSyncExternalStore(
    outbox.subscribe,
    () => outbox.ops(),
    () => outbox.ops(),
  );
export const useSyncStatus = () =>
  useSyncExternalStore(
    outbox.subscribe,
    () => outbox.getStatus(),
    () => outbox.getStatus(),
  );
